<template>
  <el-form label-width="120px" @submit.native.prevent>
    <div v-show="!isCollapsed">
      <el-form-item label="網址">
        <el-input v-model="form.UrlKey"></el-input>
      </el-form-item>

      <el-form-item label="標題">
        <el-input v-model="form.Title" @input="$emit('title-changed', form.Title)"></el-input>
      </el-form-item>

      <el-form-item label="介紹">
        <el-input v-model="form.Description" type="textarea" autosize></el-input>
      </el-form-item>

      <el-form-item label="標籤">
        <div class="w-100">
          <el-select style="width: calc(100% - 50px);margin-right: 22px;" filterable v-model="form.TagIDs" multiple placeholder="請選擇標籤">
            <template slot="empty">
              <p class="el-select-dropdown__empty">沒有資料</p>
            </template>
            <el-option
              v-for="item in tags"
              :key="'post-tag-'+item.ID"
              :label="item.Name"
              :value="item.ID">
            </el-option>
          </el-select>
          <el-button @click="openTagCreatorModal" type="primary" size="mini" icon="el-icon-plus" circle></el-button>
        </div>
        <b class="left">常用標籤:</b>
        <ul style="max-height: 32px;overflow: hidden;">
          <li v-for="tag in commonlyUsedTags"
            :key="'commly-used-post-tag-'+tag.ID"
            class="tag tag-commonly"
            @click="toggleTag(tag.ID)">
            #{{tag.Name}}
          </li>
        </ul>
      </el-form-item>

      <el-form-item label="封面圖片">
        <el-upload
          v-loading="isProcessingImage"
          ref="elupload"
          accept="image/*"
          class="left"
          style="height: 180px;"
          drag
          action
          :auto-upload="true"
          :http-request="processCoverFile">
          <img
            ref="coverImg"
            v-show="coverImageSrc"
            @load="onLoaded"
            class="preview"
            :src="coverImageSrc"
            style="max-width: 100%;max-height: 120px;"/>
          <i v-show="!(coverImageSrc)" class="el-icon-upload"></i>
          <div class="el-upload__text">
            將文件拖曳至此，或
            <em>點擊上傳</em>
          </div>
        </el-upload>
      </el-form-item>

      <el-form-item label="日期">
        <el-date-picker v-model="form.Date" class="left" type="date" placeholder="選擇日期"></el-date-picker>
      </el-form-item>
    </div>

    <div style="padding-left: 120px;">
      <div v-show="isCollapsed">詳細資訊</div>

      <el-divider>
        <i v-show="!isCollapsed" class="clickable el-icon-arrow-up" @click="isCollapsed=true">收起</i>
        <i v-show="isCollapsed" class="clickable el-icon-arrow-down" @click="isCollapsed=false">展開</i>
      </el-divider>

      <content-editor v-model="form.contentJsonArr" />
    </div>

    <post-tag-editor-modal :isShow="isShowAddeditModal" @close="isShowAddeditModal = false" @submitted="onTagAdded"/>

  </el-form>
</template>

<script>
import ImageThumbnailer from '@/utils/ImageThumbnailer.js'
import ContentEditor from '@/utils/content-editor/components/ContentEditor.vue'
import PostTagEditorModal from '@/modals/PostTagEditorModal.vue'
export default {
  components: {
    ContentEditor,
    PostTagEditorModal
  },
  props: {
    form: {
      default: () => {
        return {}
      }
    }
  },
  data: () => {
    return {
      isCollapsed: false,
      isProcessingImage: false,
      coverImageSrc: null,
      isShowAddeditModal: false
    }
  },
  computed: {
    tags () {
      return this.$store.state.post.tagList
    },
    commonlyUsedTags () {
      return this.$store.state.post.commonlyUsedTagList
    },
    isEdit () {
      return this.$route.name !== 'createPost'
    }
  },
  methods: {
    onTagAdded (tag) {
      this.toggleTag(tag.ID)
    },
    openTagCreatorModal () {
      this.isShowAddeditModal = true
    },
    // tag
    toggleTag (id) {
      let idx = this.form.TagIDs.findIndex(o => o === id)
      if (idx >= 0) {
        this.form.TagIDs.splice(idx, 1)
      } else {
        this.form.TagIDs.push(id)
      }
    },
    // cover image
    processCoverFile (e) {
      let isImg = e.file.type.indexOf('image') >= 0
      if (!isImg) {
        alert('請上傳圖片檔案')
        return
      }
      this.isProcessingImage = true
      this.$refs.elupload.clearFiles()
      // 壓縮cover image
      let coverImageCompressPromise = new Promise((resolve, reject) => {
        let opts = {
          maxWidth: 1800,
          maxHeight: 1200
        }
        ImageThumbnailer.shared.requestCompress(
          e.file,
          blob => {
            resolve(blob)
          },
          opts
        )
      })
      // 壓縮thumb
      let coverImagePreviewCompressPromise = new Promise((resolve, reject) => {
        let opts = {
          maxWidth: 450,
          maxHeight: 300
        }
        ImageThumbnailer.shared.requestCompress(
          e.file,
          blob => {
            resolve(blob)
          },
          opts
        )
      })
      // 壓縮thumb 2
      let coverImageThumbCompressPromise = new Promise((resolve, reject) => {
        let opts = {
          maxWidth: 120,
          maxHeight: 80
        }
        ImageThumbnailer.shared.requestCompress(
          e.file,
          blob => {
            resolve(blob)
          },
          opts
        )
      })
      Promise.all([
        coverImageCompressPromise,
        coverImagePreviewCompressPromise,
        coverImageThumbCompressPromise
      ]).then(results => {
        let coverBlob = results[0]
        let previewBlob = results[1]
        let thumbBlob = results[2]
        this.onThumb(coverBlob, previewBlob, thumbBlob)
      })
    },
    onThumb (blob, preview, thumb) {
      this.form.newCoverImageThumbBlob = thumb
      this.form.newCoverImagePreviewBlob = preview
      this.form.newCoverImageBlob = blob
      this.form.src = URL.createObjectURL(blob)
      this.coverImageSrc = this.form.src
      this.isProcessingImage = false
    },
    onLoaded (evt) {
      if (evt.target.src.startsWith('http')) return

      const removeBlobs = () => {
        this.form.src = undefined
        this.coverImageSrc = this.form.CoverImageUrl
        this.form.newCoverImageBlob = undefined
        this.form.newCoverImagePreviewBlob = undefined
        this.form.newCoverImageThumbBlob = undefined
      }
      const uploadBlobs = () => {
        this.isProcessingImage = true

        let coverPrefix = this.isEdit
          ? `post/${this.form.ID}/cover-`
          : `post/cover-${this.form.Title}-`
        let coverThumbPrefix = this.isEdit
          ? `post/${this.form.ID}/cover-preview-`
          : `post/cover-preview-${this.form.Title}-`
        let coverThumbBlurPrefix = this.isEdit
          ? `post/${this.form.ID}/cover-thumb-`
          : `post/cover-thumb-${this.form.Title}-`

        let promise1 = this.$services.firebase.upload(
          this.form.newCoverImageBlob,
          coverPrefix
        )
        let promise2 = this.$services.firebase.upload(
          this.form.newCoverImagePreviewBlob,
          coverThumbPrefix
        )
        let promise3 = this.$services.firebase.upload(
          this.form.newCoverImageThumbBlob,
          coverThumbBlurPrefix
        )

        Promise.all([promise1, promise2, promise3]).then(urls => {
          let coverUrl = urls[0]
          let previewUrl = urls[1]
          let thumbUrl = urls[2]
          this.form.CoverImageUrl = coverUrl
          this.form.CoverImagePreviewUrl = previewUrl
          this.form.CoverImageThumbUrl = thumbUrl
          this.form.newCoverImageBlob = undefined
          this.form.newCoverImagePreviewBlob = undefined
          this.form.newCoverImageThumbBlob = undefined
          this.form.src = undefined
          this.isProcessingImage = false
          this.coverImageSrc = this.form.CoverImageUrl
        })
      }

      let img = this.$refs.coverImg
      let size = {
        w: img.naturalWidth,
        h: img.naturalHeight
      }
      if (size.w !== 1800 || size.h !== 1200) {
        console.warn(`got error size: ${size.w}x${size.h}`)
        alert('錯誤: 檔案尺寸錯誤! 請上傳 1800x1200的圖片')
        removeBlobs()
      } else {
        uploadBlobs()
      }
      URL.revokeObjectURL(evt.target.src)
    }
  },
  created () {
    this.form.contentJsonArr = this.form.Contents
      ? JSON.parse(this.form.Contents)
      : []
    this.coverImageSrc = this.form.CoverImageUrl
  }
}
</script>

<style>
/* 常用標籤樣式 */
.tag-commonly {
  float: left;
  margin-left: 4px;
  cursor: pointer;
}
</style>
